import { FunctionComponent } from 'react';

export type TablePlaceholderProps = {
  placeholder: string;
};

const TablePlaceholder: FunctionComponent<TablePlaceholderProps> = ({ placeholder }) => {
  return <div className="TablePlaceholder">{placeholder}</div>;
};

export default TablePlaceholder;
